import React from 'react';
import { motion } from 'framer-motion';
import { GemIcon, SparklesIcon, WrenchIcon, DiamondIcon, GiftIcon, FileCheckIcon, ArrowRightIcon } from 'lucide-react';
const paths = [{
  title: 'Design an Engagement Ring',
  benefit: "We'll help you choose a stone you can actually afford and a design she'll actually wear.",
  proof: 'From $3,500 · CAD + 3D proof included',
  icon: GemIcon,
  href: '#engagement-rings'
}, {
  title: 'Remodel an Heirloom',
  benefit: "Your mother's gold. Your grandmother's diamond. Reborn into something that's truly yours.",
  proof: 'Most remodels ready in 4–6 weeks',
  icon: SparklesIcon,
  href: '#repairs'
}, {
  title: 'Repair or Restore Jewellery',
  benefit: 'Sized, re-shanked, re-tipped or rescued — by the same trusted Ardross bench families have relied on for generations.',
  proof: 'Most repairs returned within 7 days',
  icon: WrenchIcon,
  href: '#repairs'
}, {
  title: 'Find the Right Diamond',
  benefit: "Honest guidance on what's worth paying more for, and what's just clever marketing.",
  proof: 'GIA certified · conflict-free',
  icon: DiamondIcon,
  href: '#diamonds'
}, {
  title: 'A Gift That Will Be Kept',
  benefit: 'An anniversary necklace. A milestone pendant. A piece worth giving — and worth keeping.',
  proof: 'Personal advice for every budget',
  icon: GiftIcon,
  href: '#consultation'
}, {
  title: 'Book a Valuation',
  benefit: 'Insurance-grade documentation by an accredited valuer — for peace of mind, or probate.',
  proof: 'NCJV-accredited · detailed reports',
  icon: FileCheckIcon,
  href: '#consultation'
}];
export function FastPaths() {
  return <section className="section-padding bg-surface border-y border-gold/15" data-id="element-212">
      <div className="container-custom" data-id="element-213">
        <div className="max-w-3xl mb-14" data-id="element-214">
          <span className="eyebrow" data-id="element-215">Where would you like to start?</span>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.1] text-balance" data-id="element-216">
            Bring us the idea, the stone, the heirloom —{' '}
            <span className="italic text-gold-dark" data-id="element-217">or just the question.</span>
          </h2>
          <p className="text-secondary text-lg mt-5 max-w-2xl text-pretty" data-id="element-218">
            Most of our customers don't arrive knowing exactly what they want.
            They arrive with a feeling. Pick the closest match below and we'll
            take it from there.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gold/15 border border-gold/15" data-id="element-219">
          {paths.map((path, index) => <motion.a key={index} href={path.href} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.06
        }} className="group block p-8 md:p-9 bg-surface hover:bg-paper transition-colors relative" data-id="element-220">
              <path.icon className="w-7 h-7 text-gold-dark mb-6" strokeWidth={1.25} data-id="element-221" />

              <h3 className="font-serif text-xl md:text-2xl font-medium mb-3 leading-snug" data-id="element-222">
                {path.title}
              </h3>
              <p className="text-secondary text-sm leading-relaxed mb-6 text-pretty" data-id="element-223">
                {path.benefit}
              </p>

              <div className="pt-5 border-t border-gold/15 flex items-center justify-between" data-id="element-224">
                <span className="brand-mark text-[0.6rem] text-gold-dark uppercase" data-id="element-225">
                  {path.proof}
                </span>
                <ArrowRightIcon className="w-4 h-4 text-gold-dark transition-transform group-hover:translate-x-1" data-id="element-226" />
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}